import { Id } from 'src/types'

export interface AgreementsForm {
  access_code: string
  agreement_id: Id
  agreement_type: string
  branch_id: string
  domain: string
  fee_value: number
  gtw_agency_id: string
  gtw_group_id: string
  integration_type: string
  name: string
  organization_id: Id
  package_group: string
  password: string
  service_hub_id: Id
  username: string
}

export const initialValues = {} as AgreementsForm

export const defaultValues: AgreementsForm = {
  access_code: '',
  agreement_id: Math.random().toString(),
  agreement_type: 'AIR',
  branch_id: '',
  domain: '',
  fee_value: 0,
  gtw_agency_id: '',
  gtw_group_id: '',
  integration_type: 'CONSOLIDATOR',
  name: '',
  organization_id: '',
  package_group: '',
  password: '',
  service_hub_id: '',
  username: ''
}
